module.exports = __webpack_public_path__ + "static/media/Hidden.0bab8196.jpg";